import React from 'react';
import { Link } from 'react-router-dom';
import './PlayerStats.css';

/**
 * PlayerStats component
 * Displays player performance metrics
 * T069: Player statistics display with performance metrics
 */
const PlayerStats = ({ player, team, stats }) => {
  if (!player || !stats) {
    return (
      <div className="player-stats-empty">
        <p>Player statistics not available.</p>
      </div>
    );
  }

  const formatPercentage = (value) => {
    return value ? `${value.toFixed(1)}%` : '0.0%';
  };

  const statItems = [
    { label: 'Games Played', value: stats.gamesPlayed || 0 },
    { label: 'Games Won', value: stats.gamesWon || 0 },
    { label: 'Games Lost', value: stats.gamesLost || 0 },
    { label: 'Win Percentage', value: formatPercentage(stats.winPercentage) },
    { label: 'Break Attempts', value: stats.breakAttempts || 0 },
    { label: 'Break Success Rate', value: formatPercentage(stats.breakSuccessRate) },
  ];

  return (
    <div className="player-stats">
      <div className="player-info">
        <h2 className="player-name">{player.name}</h2>
        {team && (
          <Link to={`/teams/${team.teamId}`} className="player-team">
            {team.name}
          </Link>
        )}
      </div>

      <div className="stats-grid">
        {statItems.map((item) => (
          <div key={item.label} className="stat-item">
            <span className="stat-label">{item.label}</span>
            <span className="stat-value">{item.value}</span>
          </div>
        ))}
      </div>

      {stats.gamesPlayed === 0 && (
        <div className="no-stats-message">
          <p>This player hasn't played any games yet.</p>
        </div>
      )}
    </div>
  );
};

export default PlayerStats;
